import { render, staticRenderFns } from "./FeatureBox.vue?vue&type=template&id=39741a4c&"
import script from "./FeatureBox.vue?vue&type=script&lang=js&"
export * from "./FeatureBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports